import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

export default function ProjectImage({ image, projectTitle, index, noSpacer = false }) {
  const containerRef = useRef(null)
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start start', 'end start'],
  })

  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.75])
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [1, 1, 0.9])

  return (
    <div ref={containerRef} className={noSpacer ? 'absolute inset-0' : 'relative'}>
      <motion.div
        style={noSpacer ? { scale } : { scale, opacity }}
        className={`${
          noSpacer ? 'absolute' : 'sticky'
        } top-0 z-10 flex h-screen w-full items-center justify-center overflow-hidden rounded-2xl shadow-xl`}
      >
        <img
          src={typeof image === 'string' ? image : image?.url || image}
          alt={`${projectTitle} — ${index + 1}`}
          className="h-full w-full object-cover"
          loading={index === 0 ? 'eager' : 'lazy'}
        />
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-black/10 via-transparent to-background/20" />
      </motion.div>
      {!noSpacer && <div className="h-screen" />}
    </div>
  )
}
